import { Box, Card, CardContent, Tab, Tabs, IconButton } from '@mui/material';
import React from 'react';
import InsightsWithMessagePreview from './InsightsWithMessagePreview.tsx';
import SummaryTable from './SummaryTable.tsx';
import { useNavigate } from 'react-router';
import Breadcrumb from '../../../Shared/Breadcrumb/index.tsx';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import DynamicBreadcrumbs from '../../../Shared/Breadcrumb/index.tsx';
import HomeIcon from '@mui/icons-material/Home';


// Define a11yProps
function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const TemplateDetailsV1 = () => {
    const [value, setValue] = React.useState(0);
    const navigate = useNavigate();

    const breadcrumbLabel = value === 0 ? 'Summary' : 'Insights';

    const breadcrumbsData = [
        { label: <IconButton color='primary'><HomeIcon /></IconButton>, href: "/" },
        { label: "Templates", href: '/r/whatsapp/template-list' },
        { label: breadcrumbLabel },
    ];

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Box>
            <DynamicBreadcrumbs items={breadcrumbsData} onBreadcrumbClick={(event, item: { label: string, href: string }) => {
                if (item?.href) {
                    navigate(item?.href);
                }
            }}
            />
            <Card>
                <CardContent>

                    <Tabs value={value} onChange={handleChange}>
                        <Tab label="Summary" {...a11yProps(0)} />
                        <Tab label="Insights" {...a11yProps(1)} />
                    </Tabs>
                </CardContent>
            </Card>
            {value === 0 && (
                <Box sx={{ pt: 2 }}>
                    <SummaryTable />
                </Box>
            )}

            {value === 1 && (
                <Box>
                    <InsightsWithMessagePreview />
                </Box>
            )}
        </Box>
    );
};

export default TemplateDetailsV1;
